import { Input } from "@mantine/core";
import type { IHeaderParams } from "ag-grid-community";
import { useEffect, useRef, useState } from "react";

export function EditableHeader({
  displayName,
  onHeaderValueChanged,
}: IHeaderParams & {
  onHeaderValueChanged: (newValue: string) => void;
}) {
  const [value, setValue] = useState(displayName || "");
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    setValue(displayName || "");
  }, [displayName]);

  const handleBlur = () => {
    if (value !== displayName && value.trim() !== "") {
      onHeaderValueChanged(value.trim());
    } else if (value.trim() === "") {
      // Reset to original if empty
      setValue(displayName || "");
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      e.currentTarget.blur();
    } else if (e.key === "Escape") {
      setValue(displayName || "");
      e.currentTarget.blur();
    }
  };

  return (
    <Input
      ref={inputRef}
      value={value}
      onChange={(e) => setValue(e.currentTarget.value)}
      onBlur={handleBlur}
      onKeyDown={handleKeyDown}
      size="xs"
      styles={{
        input: {
          height: "24px",
          fontSize: "12px",
          padding: "2px 8px",
          border: "1px solid transparent",
        },
        wrapper: {
          width: "100%",
        },
      }}
    />
  );
}

